/**
 * MediaUrl entity class
 */

/**
 * MediaUrlFactory
 * returns MediaUrl entity class
 *
 * @class MediaUrlFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.MediaUrl} class
 *
 * @ngdoc factory
 * @name mwApp.factory:MediaUrlFactory
 */
/* @ngInject */
export default function MediaUrlFactory (Entity) {
  /* === MediaUrl class === */

  /**
   * MediaUrl model
   *
   * @class MediaUrl
   * @classdesc MediaUrl model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing MediaUrl entity fields
   * @return {models.MediaUrl} MediaUrl entity
   */
  function MediaUrl () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  MediaUrl.prototype = Object.create(Entity.prototype)
  MediaUrl.prototype.constructor = MediaUrl

  /* === MediaUrl instance methods & fields === */

  Object.assign(MediaUrl.prototype, {

    /**
     * instance fields
     *
     * @memberof models.MediaUrl#
     * @type {Object}
     */
    _fields: {
      id: Number,
      mediaUrl: String,
      playbackTokenGenerator: 'PlaybackTokenGenerator',
      trailerUrl: String
    }

  })

  /* === MediaUrl static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(MediaUrl, Entity)
  MediaUrl._name = 'MediaUrl'
  MediaUrl.init()

  return MediaUrl
}
